import { generateNgrxServiceClient } from '@essent/ngrx-service-wrapper';
import { genericClient } from '@integration/api-client/generic';

export const { actions: GenericApiActions, effects: GenericApiEffects } =
  generateNgrxServiceClient('Generic', genericClient);
